import React from "react";
import { Router } from "./Router/Router";

export const App = () => {
  return (
    <div className="app-container">
      <div className="noise-overlay"></div>
      <div className="router-container">
        <Router />
      </div>
    </div>
  );
};

export default App;
